import { graphql } from 'react-relay';

export const CheckoutPixAutomaticAdd = graphql`
  mutation CheckoutPixAutomaticAddMutation(
    $input: CheckoutPixAutomaticAddInput!
  ) {
    CheckoutPixAutomaticAdd(input: $input) {
      paymentSubscription {
        id
        pixRecurring {
          paymentLinkUrl
        }
      }
      error
      success
    }
  }
`;
